import axios from "axios";

const API_ENDPOINT = "https://groqprompt.netlify.app/api/ai";

interface AIResponse {
  result: string;
}

export const fetchAIChessContent = async (topic: string): Promise<string> => {
  // Cấu trúc Prompt kỹ thuật (Prompt Engineering) để ép kiểu dữ liệu trả về
  const prompt = `
    Đóng vai trò là một Đại Kiện Tướng Cờ Tướng Việt Nam và là một người thầy tận tâm.
    Nhiệm vụ: Viết bài hướng dẫn chi tiết, trình bày đẹp (Markdown) về chủ đề: "${topic}".

    QUY TẮC BẮT BUỘC VỀ KÝ HIỆU (NOTATION):
    1. TUYỆT ĐỐI KHÔNG dùng FEN hoặc ký hiệu cờ vua phương Tây (như e4, Nf3, R1-d1).
    2. BẮT BUỘC dùng "Ký Hiệu Cờ Tướng Việt Nam" chuẩn:
       - Tên quân: Tướng, Sĩ, Tượng, Xe, Pháo, Mã, Tốt.
       - Hành động: Tấn (.), Thoái (/), Bình (-).
       - Ví dụ chuẩn: Pháo 2 bình 5 (P2-5), Mã 8 tấn 7 (M8.7), Xe 9 thoái 1 (X9/1).
    3. Nếu liệt kê ván đấu, hãy trình bày dạng bảng hoặc danh sách từng nước đi rõ ràng (Tiên - Hậu).
    4. Giọng văn: Thân thiện, kiếm hiệp, đậm chất cờ tướng dân gian Việt Nam.
  `;

  try {
    const response = await axios.post<AIResponse>(API_ENDPOINT, {
      prompt: prompt,
    });
    return response.data.result;
  } catch (error) {
    console.error("Lỗi khi gọi API:", error);
    return "Lỗi kết nối: Đại sư đang bận thi đấu, vui lòng thử lại sau giây lát...";
  }
};
